// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################


export const INFO = 'INFO';

export const WARN = 'WARN';

export const ERROR = 'ERROR';

/**
 * Seznam všech hodnot.
 */
export const values = [
    INFO,
    WARN,
    ERROR
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [INFO]: {caption: ''},
    [WARN]: {caption: ''},
    [ERROR]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}